import React, { createContext, useContext, useState } from 'react';
import { aux } from '../../../theme';
import { MobileContext } from './withMobile';
import { BreakpointContext } from './withBreakpoint';

export const LayoutContext = createContext();

const calculateNavWidth = (isMobile, isBelowSize) => {
  if (!isMobile) {
    if (isBelowSize) return aux.desktop.navbarWidthSm;
    if (!isBelowSize) return aux.desktop.navbarWidthLg;
  }
  return null;
};

export const LayoutProvider = ({ children }) => {
  const { isMobile } = useContext(MobileContext);
  const { isBelow } = useContext(BreakpointContext);

  const [forceCollapse, setForceCollapse] = useState(false);
  const toggleForceCollapse = () => setForceCollapse(!forceCollapse);

  const navHeight = isMobile ? aux.mobile.navbarHeight : null;
  const navWidth = calculateNavWidth(isMobile, isBelow('xl') || forceCollapse);

  return (
    <LayoutContext.Provider
      value={{
        navHeight,
        navWidth,
        headerHeight: aux.headerHeight,
        forceCollapse,
        toggleForceCollapse
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const withLayout = Component => props => (
  <LayoutContext.Consumer>
    {context => <Component {...props} layoutContext={context} />}
  </LayoutContext.Consumer>
);
